export default __webpack_public_path__ + "static/media/notif_assign_person.dba71a68.svg";